import React, {useState, useEffect} from 'react'
import { Routes, Route } from "react-router-dom";
import Home from '../screens/Home/Home';
import Schedule from '../screens/Schedule/Schedule';
import ThankYouPage from '../screens/ThankYouPage/ThankYouPage';
import TypeForm from "../screens/TypeForm/TypeForm"
import ScheduleHighValue from "../screens/ScheduleHighValue/ScheduleHighValue"

import { getLeads } from "../services/leads.js"



export default function MainContainer(props) {
  const [allLeads, setAllLeads] = useState([])


  useEffect(() => {
    const fetchLeads = async () => {
      const leads = await getLeads();
      setAllLeads(leads)
    }
    fetchLeads()
    // eslint-disable-next-line
  }, [])
  


  
  

  return (
    <Routes>
    <Route exact path="/typ" element={<ThankYouPage />} />
    <Route exact path="/schedule-hv" element={<ScheduleHighValue />} />
    <Route exact path="/schedule" element={<Schedule />} />
    <Route exact path="/form" element={<TypeForm siteContent={props.siteContent} />} />
    <Route exact path="/" element={<Home />} />
    </Routes>
  )
}